<template>
  <SidebarModal :modal="modal">
    <ImageZoom
      class="bg-gray-100 dark:bg-neutral-900/90"
      :src="modal?.payload?.default_url"
    ></ImageZoom>
  </SidebarModal>
</template>

<script>
import SidebarModal from '@/components/sidebar/SidebarModal.vue';
import ImageZoom from '@/components/ui/ImageZoom';

export default {
  name: 'ImageModal',
  components: {
    SidebarModal,
    ImageZoom,
  },
  props: {
    modal: {
      type: Object,
      required: true,
    },
  },
};
</script>
